import React from 'react';
import cn from 'classnames';
import { SliderButton } from './SliderButton';

import * as styles from './SliderControl.module.scss';

export function SliderControl({
  className,
  current,
  to,
  handleNext,
  handlePrev,
  theme,
  infinite = true,
}) {
  return (
    <div className={cn(styles.wrapper, className, theme && styles[theme])}>
      {current && to && <div className={cn(styles.text, styles[theme])}>{`${current}/${to}`}</div>}
      <div className={styles.buttons}>
        <SliderButton
          className={styles.prev}
          handleClick={handlePrev}
          disabled={!infinite && current === 1}
        />
        <SliderButton
          className={styles.next}
          handleClick={handleNext}
          disabled={!infinite && current === to}
        />
      </div>
    </div>
  );
}
